<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page -->
            <h1 class="page__title">{{ title_page }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow>
                    <CCol sm="12">
                        <CCard>
                            <CCardBody>
                                <CTabs variant="tabs" :active-tab="0">
                                    <!-- Tab general -->
                                    <CTab :title="$t('General')">
                                        <CCard bodyWrapper>
                                            <CInput
                                                :isValid="checkIfFormValid({ form_name:'database', field_name:'name' })"
                                                :value.sync="$v.forms.database.name.$model"

                                                :label="$t('Name')"
                                                :placeholder="$t('Enter the database name')"
                                                :invalidFeedback="$t('Name is required')"
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <SelectCountry 
                                                :isValid="checkIfFormValid({ form_name:'database', field_name:'country_id' })"
                                                :value.sync="$v.forms.database.country_id.$model"

                                                :label="$t('Country')"
                                                :placeholder="$t('Select an option')"
                                                :invalidFeedback="$t('Country is required')"
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <SelectLanguage
                                                :isValid="checkIfFormValid({ form_name:'database', field_name:'language_id' })"
                                                :value.sync="$v.forms.database.language_id.$model" 
                                                
                                                :label="$t('Language')"
                                                :placeholder="$t('Select an option')"
                                                :invalidFeedback="$t('Language is required')"
                                                :horizontal="default_horizontal"
                                                size="sm"
                                            />
                                            <CRow :form="true">
                                                
                                                <label class="col-form-label col-sm-2 col-form-label-sm">{{ $t('Exportable') }}:</label>
                                                
                                                <CCol sm="10" class="input-group-sm">

                                                        <LInputRadioGroup
                                                        :checked.sync="forms.database.exportable"
                                                        :options="[
                                                            { value: true, label: $t('Yes')}, 
                                                            { value: false, label: $t('No')},
                                                        ]"
                                                        :inline="true"
                                                    />

                                                </CCol>
                                            </CRow> 
                                        </CCard>
                                    </CTab>

                                </CTabs>
                            </CCardBody>
                            <CCardFooter class="d-flex">
                                <ButtonSave
                                    color="success"
                                    @click="save()"
                                />
                                <!-- Button back -->
                                <ButtonBack />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
    
</template>

<script>

/**
 * Components
 */
import SelectCountry from "£lement/SelectCountry";
import SelectLanguage from "£lement/SelectLanguage";
import ButtonBack from "£lement/ButtonBack";
import ButtonSave from "~/components/ButtonSave.vue";
import LInputRadioGroup from "~/components/LInputRadioGroup";


/**
 * Mixins
 */
import pageMixin from '~/mixins/page.js';

/**
 * Others
 */
import { cilSave, cilArrowThickFromRight,cilSettings, cilPencil,cilTrash } from '@coreui/icons';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";


export default {
    name:"DatabaseViewPage",
    middleware: ["auth","page"],
    mixins: [ validationMixin, pageMixin ],
    components:{
        SelectCountry,
        SelectLanguage,
        ButtonBack,
        ButtonSave,
        LInputRadioGroup
    },
    icons:{
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPencil,
        cilTrash
    },
    data(){
        return {
            forms:{
                database:{
                    name:null,
                    country_id:null,
                    language_id:null,
                    exportable:true
                }
            },
            page:{
                _loading:true,
                title:"Database config",
            }
        }
    },

    validations: {
        forms:{
            database:{
                name: {
                    required
                },
                country_id: {
                    required
                },
                language_id:{
                    required
                },
                exportable:{
                    required
                }
            }
        }
    },
    computed:{
        title_page:function(){
            let title_page = "New database";
            if(this.$route.query.view_type == "edit"){
                title_page =  "Edit database";
            }
            return this.$t(title_page);
        },
        database_id:function(){
            return this.$route.query.database_id;
        }
    },
    methods:{
        async loadPage(){
            await this.updateForm({
                form_name:"database",
                url:`/db/${this.database_id}`
            });
            this.page._loading = false;
            this.$store.dispatch('page/updateLoading', {
                loading: false,
            });
        },
        async save(){
            this.$store.dispatch('page/updateLoading', {
                loading: true,
            });
            let { status } = await this.sendForm({
                    form_name:'database',
                    url:'/db', 
                    url_param:this.database_id
                });
            if(status)
                this.$router.push({ name: 'database' });
        }

    },
    async mounted(){
        await this.loadPage();
    }
}
</script>
